import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const NavBarRwdWrapperStyles = css`
  width: 100%;
  height: 48px;
  background: linear-gradient(
    ${colors.blueGradientStart} 0%,
    ${colors.blueGradientEnd} 100%
  );
`

export const NavBarRwdWrapperDesktopStyles = css`
  display: none;
`;

export const MenuButtonStyles = css`
  width: 54px;
  height: 100%;
  background: linear-gradient(
    ${colors.goldGradientStart} 0%,
    ${colors.goldGradientEnd} 100%
  );
  align-items: center;
  justify-content: center;
  &:hover {
    background: linear-gradient(
      ${colors.goldGradientHoverStart} 0%,
      ${colors.goldGradientHoverEnd} 100%
    );
  }
`

export const LogoWrapperStyles = css`
  margin-top: 2px;
  width: 85px;
`
